import { useEffect } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../../components/AntdAddons";

/**
 * Renders a form component for adding or editing a record in the Cms module.
 *
 * @param {object} props - The component props.
 * @param {object} props.form - The form instance.
 * @param {string} props.id - The form ID.
 * @param {function} props.handleSubmit - The function to handle form submission.
 * @param {function} props.onValuesChange - The function to handle form value changes and update the form fields.
 * @param {object} props.editValues - The values to edit in the form fields, if value already exists.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  useEffect(() => {
    if (editValues) {
      form.setFieldsValue(editValues);
    }
  }, [editValues, form]);

  /**
   * Process the form data and handle the form submission.  
   */
  const onFinish = (data: any) => {
    if (data.description !== String(data.description)) {
      data.description = data.description.level.content;
    }
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text required name="title" label="Title" />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Editor
              name="description"
              label="Description"
              initValue={form.getFieldValue("description")}
              editorChange={(e: any) => {
                form.setFieldsValue({ description: e });
                onValuesChange();
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text name="meta_title" label="Meta Title" />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text label="Meta Keyword" />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.TextArea
              name="meta_description"
              label="Meta Description"
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
